/*
 * @Description:
 * @Author: rongcheng
 * @@后台人员: 郑晨茹
 * @Date: 2022-02-23 16:27:02
 * @LastEditors: rongcheng
 * @LastEditTime: 2022-04-02 16:12:23
 */

import service from '@/utils/request'

// // 管理员权限详情
// export const detailOfAccountPermission = (params: any) =>
//   service.request({
//     method: 'post',
//     url: 'admin/account/detailOfAccountPermission',
//     data: params
//   })
// 获取树形结构
export const getMenuTree = (params: any) => {
  return service.request({
    method: 'post',
    url: '/menu/menuTree',
    data: params
  })
}
// 菜单删除
export const setPermissionRemove = (params: any) => {
  return service.request({
    method: 'post',
    url: '/menu/remove',
    data: params
  })
}
